
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 30"}},[_c('defs',[_c('path',{attrs:{"id":"a","d":"M101.667 236.667c0 9.62-10.709 17.82-11.165 18.165a.831.831 0 0 1-1.004 0c-.456-.345-11.165-8.545-11.165-18.165C78.333 230.234 83.567 225 90 225s11.667 5.234 11.667 11.667zm-6.667 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"}})]),_c('use',{attrs:{"fill":"#f2644a","xlink:href":"#a","transform":"translate(-78 -225)"}})])
      }
    
      }
    